package com.veldekar.components.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider

/**
 * SessionListLinks renders a list of links to each session page.
 *
 * @param reverseChronological If true, sessions are sorted newest first (default).
 *                              If false, sessions are sorted oldest first.
 */
@Composable
fun SessionListLinks(reverseChronological: Boolean = true) {
    val orderedSessions = if (reverseChronological) {
        sessions.reversed()
    } else {
        sessions
    }

    Column(Modifier.fillMaxWidth()) {
        orderedSessions.forEachIndexed { index, session ->
            when (session) {
                is SessionListData.Simple -> {
                    SimpleSessionListItem(session.path, session.date, session.veldekarDates)
                }
                is SessionListData.Full -> {
                    SessionListItem(
                        path = session.path,
                        title = session.title,
                        description = session.description,
                        imageUrl = session.imageUrl,
                        imageWidth = session.imageWidth,
                        imageHeight = session.imageHeight,
                        date = session.date,
                        veldekarDates = session.veldekarDates,
                        isAiText = session.isAiText,
                        isAiImage = session.isAiImage,
                        aiHint = session.aiHint,
                        eagerImage = index == 0,
                    )
                }
            }
            if (index < orderedSessions.size - 1) {
                HorizontalDivider()
            }
        }
    }
}
